import { EnvironmentProviders } from '@angular/core';
import { provideAuth0 } from '@auth0/auth0-angular';
import { Environment } from '../../environments/environment.type';

export function provideAuth(environment: Environment): EnvironmentProviders[] {
  const allowedList = [
    ...Object.values(environment.origins).map(url => `${url}/*`),
    `${environment.NSSignalR.url}/*`
  ];
  return [
    provideAuth0({
      domain: environment.auth0.loginUrl,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/${window.location.search}`,
        audience: 'https://bannerflow.com/resources/',
        scope: 'openid profile email offline_access'
      },
      httpInterceptor: {
        allowedList: allowedList
      },
      useRefreshTokens: true,
      cacheLocation: 'localstorage'
    })
  ];
}
